import React from 'react'

// Material UI
import {
    Divider,
    TableBody,
    TableFooter,
    TableHead,
    TableSortLabel,
    TextField,
    Typography,
    withStyles
} from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import Button from "@material-ui/core/Button";

// Constants
import {
    NEEDS_REVIEW_STATUS,
    APPROVE_STATUS,
    INVOICE_ITEM_CELLS_LEFT,
    INVOICE_ITEM_CELLS_RIGHT,
    ATTACHMENTS_INFO
} from "./constants";

// Styles
import "./EditInvoices.css"

// Custom Components
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import PDFViewer from "../../global/PDFViewer";
import {IconButton} from "@material-ui/core"
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import PropTypes from "prop-types";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import DeleteIcon from "@material-ui/icons/Delete";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import styles from "../../../pages/Dashboard/DashboardFinal/DashboardFinal.module.css";
import DescriptionIcon from "@material-ui/icons/Description";
import FileUpload from "../../global/FileUpload";
import {getByteArray} from "../../global/constants";
import {PACKING_SLIP_INFO} from "../../purchaseOrders/constants";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { MenuItem, Tooltip } from '@mui/material';
import DateFnsUtils from "@date-io/date-fns";
import Autocomplete from "@material-ui/lab/Autocomplete";
import format from "date-fns/format";
import {parseISO} from "date-fns";

const CurrencyCodeField = withStyles({
    root: {
        width: "10%",
        paddingLeft: "5px",
        paddingRight: "5px"
    },
})(TextField);

const StyledTextField = withStyles({
    root: {
        paddingLeft: "5px",
        paddingRight: "5px"
    }
})(TextField)

const LeftMostTextField = withStyles({
    root: {
        paddingRight: "5px"
    }
})(TextField)

const RightMostTextField = withStyles({
    root: {
        paddingLeft: "5px",
    },
})(TextField)

const StyledDateField = withStyles({
    root: {
        paddingLeft: "5px",
        paddingRight: "5px",
        width: "20%"
    }
})(KeyboardDatePicker)

class EditInvoices extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            deleteIndex: -1,
            currencyCode: props.editing.currencyCode ??
                  props.editing.supplierInvoiceItems?.[0]?.currencyCode ??
                  '',
        }
    }


    componentDidMount() {
        if (this.props.isCreateInvoice) {
            this.resetInvoiceFields(this.props.isCreateInvoice);
        }

        if (this.props.editing.isManual === false) {
            this.resetInvoiceFields(false);
        }
    }

    componentDidUpdate(prevProps) {

        if (this.props.isCreateInvoice !== prevProps.isCreateInvoice) {
            this.resetInvoiceFields(this.props.isCreateInvoice);
        }

        if (this.props.editing.supplierInvoiceId !== prevProps.editing.supplierInvoiceId) {
            const currency =
              this.props.editing.currencyCode ??
              this.props.editing.supplierInvoiceItems?.[0]?.currencyCode ??
              '';
            if (currency !== this.state.currencyCode) {
              this.setState({ currencyCode: currency });
            }
        }

    }

    resetInvoiceFields = (isCreate) => {
        if (isCreate) {
            this.props.handleChange('newInvoice', true);
            this.props.handleChange('isManual', true);
            this.props.handleChange('status', 'Needs Review');
            this.props.handleChange('currency', '');
        } else {
            this.props.handleChange('newInvoice', false);
            this.props.handleChange('isManual', false);
        }
    }

    handleDateChange = (e) => {
    if (!e || isNaN(e.getTime())) {
        // cleared date
        this.props.handleChange('date', null)
        return
    }

    const month = e.getMonth() + 1
    const date = e.getDate()

    const dateString =
        e.getFullYear() +
        '-' +
        (month < 10 ? '0' + month : month) +
        '-' +
        (date < 10 ? '0' + date : date)

    this.props.handleChange('date', dateString)
}

    getAmountSubTotal = () => {
        //only show those line items with quantity > 0
        const updatedItems = this.props.editing.supplierInvoiceItems?.filter(invoice => invoice.quantity > 0);

        // if a lineItem have tax as a null value, assign it a 0.00, Also calulates the Amount subtotal and Tax subtotal
        let amountTotal = 0
        updatedItems.map(item =>{
            amountTotal += parseFloat(item.amount)
        })
        return this.props.formatDollar(amountTotal, true)
    }

    getTaxSubTotal = () => {
        //only show those line items with quantity > 0
        const updatedItems = this.props.editing.supplierInvoiceItems?.filter(invoice => invoice.quantity > 0);

        // if a lineItem have tax as a null value, assign it a 0.00, Also calulates the Amount subtotal and Tax subtotal
        let taxTotal = 0
        let taxChanged = false
        updatedItems.map(item =>{
            if (!item.tax) {
                item.tax = "0.00"
                taxChanged = true
            }
            taxTotal += parseFloat(item.tax)
        })
        return this.props.formatDollar(taxTotal, true)
    }

    getSupplierProducts = () => {
      const supplierId = this.props.editing.supplierId;
      if (!supplierId) return [];

      const supplier = (this.props.suppliers || []).find(
        (s) => s.supplierId === supplierId
      );

      const products = supplier?.supplierProducts || [];

      // Sort by shortcode alphabetically
      return products.slice().sort((a, b) =>
        a.shortcode.localeCompare(b.shortcode)
      );
    };

    render() {

    const hasLineItems =
      Array.isArray(this.props.editing.supplierInvoiceItems) &&
      this.props.editing.supplierInvoiceItems.length > 0;

        if (!this.props.editing) return (<></>)
        return (
          <>
            {(this.props.viewing && (
              <PDFViewer data={this.props.pdfData} scale={this.props.scale} />
            )) || (
              <div className={'invoiceWrapper'}>
                <div className="infoRow">
                  {this.props.editing.isManual ? (
                    <Autocomplete
                      style={{ width: '250px' }}
                      options={this.props.suppliers || []}
                      getOptionLabel={(option) => option.name || ''}
                      value={
                        this.props.editing.supplierId
                          ? this.props.suppliers.find(
                              (s) =>
                                s.supplierId === this.props.editing.supplierId
                            ) || null
                          : null
                      }
                      onChange={(e, value) => {
                        if (value) {
                          this.props.handleChange('supplierName', value.name);
                          this.props.handleChange(
                            'supplierId',
                            value.supplierId
                          );
                          this.props.handleChange(
                            'currency',
                            value?.currencyCode
                          );
                          const updatedItems = (
                            this.props.editing.supplierInvoiceItems || []
                          ).map((item) => ({
                            ...item,
                            shortcode: '',
                            supplierPartNumber: '',
                            unitPrice: '',
                            amount: '',
                            tax: '',
                          }));

                          // 3. Update the items in state
                          this.props.handleChange(
                            'supplierInvoiceItems',
                            updatedItems
                          );
                        } else {
                          this.props.handleChange('supplierName', '');
                          this.props.handleChange('supplierId', null);

                          const clearedItems = (
                            this.props.editing.supplierInvoiceItems || []
                          ).map((item) => ({
                            ...item,
                            shortcode: '',
                            supplierPartNumber: '',
                            unitPrice: '',
                            amount: '',
                            tax: '',
                          }));
                          this.props.handleChange(
                            'supplierInvoiceItems',
                            clearedItems
                          );
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Supplier Name"
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                          error={!this.props.editing.supplierName}
                        />
                      )}
                    />
                  ) : (
                    <LeftMostTextField
                      variant="outlined"
                      label="Supplier Name"
                      InputLabelProps={{ shrink: true }}
                      name="supplierName"
                      value={this.props.editing.supplierName}
                      InputProps={{ readOnly: true }}
                      error={!this.props.editing.supplierName}
                    />
                  )}
                  <StyledTextField
                    variant="outlined"
                    label="PO Number"
                    InputLabelProps={{ shrink: true }}
                    name="poNumber"
                    value={this.props.editing.poNumber}
                    error={!this.props.editing.poNumber}
                    onChange={(e) =>
                      this.props.handleChange(e.target.name, e.target.value)
                    }
                    onBlur={(e) => {
                      this.props.handleChange(
                        e.target.name,
                        e.target.value.trim()
                      );
                      this.props.handlePONumberChange(e.target.value);
                    }}
                  />
                  <StyledTextField
                    variant="outlined"
                    label="Invoice Number"
                    InputLabelProps={{ shrink: true }}
                    name="invoiceNumber"
                    value={this.props.editing.invoiceNumber}
                    error={!this.props.editing.invoiceNumber}
                    onChange={(e) =>
                      this.props.handleChange(e.target.name, e.target.value)
                    }
                  />
                  <StyledDateField
                    autoOk
                    variant="inline"
                    inputVariant="outlined"
                    label="Date"
                    format="yyyy-MM-dd"
                    error={!this.props.editing.date}
                    value={
                      this.props.editing.date
                        ? new Date(this.props.editing.date).setDate(
                            new Date(this.props.editing.date).getDate() + 1
                          )
                        : null
                    }
                    onChange={this.handleDateChange}
                  />
                  <StyledTextField
                    style={{ width: '15%' }}
                    variant="outlined"
                    label="Tax Percentage"
                    InputLabelProps={{ shrink: true }}
                    name="taxPercentage"
                    value={
                      this.props.editing.taxPercentage ??
                      this.props.defaultTaxPercentage
                    }
                    // error={!this.props.editing.poNumber}
                    onChange={(e) =>
                      this.props.handleChange(e.target.name, e.target.value)
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">%</InputAdornment>
                      ),
                    }}
                  />

                  <Autocomplete
                    id="currency-select"
                    options={['CAD', 'USD']}
                    style={{
                      width: '130px',
                      marginLeft: '4px',
                      marginRight: '4px',
                    }}
                    value={
                      this.props.editing.currency ||
                      this.state.currencyCode ||
                      this.props.currency ||
                      null
                    }
                    onChange={(event, newValue) => {
                      // newValue will be 'CAD', 'USD', or null
                      this.setState({ currencyCode: newValue });
                      this.props.handleChange('currency', newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Currency"
                        variant="outlined"
                        name="currency"
                        InputLabelProps={{ shrink: true }}
                        error={
                          !this.props.editing.currency &&
                          !this.state.currencyCode
                        }
                      />
                    )}
                    readOnly={false}
                    disableClearable={true}
                  />

                  {!this.props.isCreateInvoice && (
                    <RightMostTextField
                      variant="outlined"
                      label="Invoice Status"
                      InputProps={{ readOnly: true }}
                      InputLabelProps={{ shrink: true }}
                      name="invoicestatus"
                      value={this.props.editing.status ?? ''}
                    />
                  )}
                </div>
                <br />
                <Divider className="divider" />
                <div className="lineItems">
                  <p>Line Items</p>
                  {this.props.editing.supplierInvoiceItems?.map(
                    (invoiceItem, index) => (
                      <React.Fragment key={index}>
                        <div className="lineItemRow">
                          {INVOICE_ITEM_CELLS_LEFT.map((item, i) => {
                            return item.id === 'shortcode' ? (
                              <Autocomplete
                                style={{ width: '10%' }}
                                options={this.getSupplierProducts()}
                                getOptionLabel={(option) =>
                                  option.shortcode || ''
                                }
                                value={
                                  this.getSupplierProducts().find(
                                    (p) => p.shortcode === invoiceItem.shortcode
                                  ) || null
                                }
                                onChange={(e, value) => {
                                  if (value) {
                                    // Auto-populate part number and unit price
                                    this.props.handleItemChange(
                                      'shortcode',
                                      value.shortcode,
                                      index
                                    );
                                    this.props.handleItemChange(
                                      'supplierPartNumber',
                                      value.supplierPartNumber,
                                      index
                                    );
                                    this.props.handleItemChange(
                                      'unitPrice',
                                      value.price,
                                      index
                                    );
                                  } else {
                                    // Clear values if nothing selected
                                    this.props.handleItemChange(
                                      'shortcode',
                                      '',
                                      index
                                    );
                                    this.props.handleItemChange(
                                      'supplierPartNumber',
                                      '',
                                      index
                                    );
                                    this.props.handleItemChange(
                                      'unitPrice',
                                      '',
                                      index
                                    );
                                  }
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label={item.label + '*'}
                                    variant="outlined"
                                    InputLabelProps={{ shrink: true }}
                                    error={!invoiceItem.shortcode}
                                  />
                                )}
                              />
                            ) : (
                              <TextField
                                style={{ width: '10%' }}
                                key={'item' + i}
                                variant="outlined"
                                label={item.label + '*'}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{
                                  style: {
                                    textAlign: item.rightAlign
                                      ? 'right'
                                      : 'left',
                                  },
                                }}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      {item.addDollar ? '$' : ''}
                                    </InputAdornment>
                                  ),
                                  readOnly: item.readOnly,
                                }}
                                name={item.id}
                                value={
                                  // Only use formatDollar if it's a dollar field AND NOT the unitPrice
                                  item.addDollar && item.id !== 'unitPrice'
                                    ? this.props.formatDollar(
                                        invoiceItem[item.id]
                                      )
                                    : invoiceItem[item.id] || ''
                                }
                                error={
                                  // Check if the value is missing
                                  !(item.addDollar && item.id !== 'unitPrice'
                                    ? this.props.formatDollar(
                                        invoiceItem[item.id]
                                      )
                                    : invoiceItem[item.id])
                                }
                                helperText={
                                  this.props.itemError.index === index &&
                                  this.props.itemError.id === item.id
                                    ? 'Field is required'
                                    : ''
                                }
                                onChange={(e) =>
                                  this.props.handleItemChange(
                                    e.target.name,
                                    e.target.value,
                                    index
                                  )
                                }
                                onBlur={(e) => {
                                  let val = e.target.value;
                                  if (item.id === 'unitPrice' && val) {
                                    val = parseFloat(val).toFixed(3);
                                  }
                                  this.props.handleBlurField(
                                    item.id,
                                    val,
                                    index
                                  );
                                }}
                              />
                            );
                          })}
                          <div
                            style={{
                              width: '10%',
                              display: 'flex',
                              alignItems: 'flex-start',
                              flexDirection: 'column',
                            }}
                          >
                            <TextField
                              style={{ width: '100%' }}
                              key={'item' + INVOICE_ITEM_CELLS_LEFT.length}
                              variant="outlined"
                              label={'Discount*'}
                              InputLabelProps={{ shrink: true }}
                              inputProps={{ style: { textAlign: 'right' } }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    {'$'}
                                  </InputAdornment>
                                ),
                                readOnly: false,
                              }}
                              name={'discount'}
                              value={this.props.formatDollar(
                                invoiceItem['discount']
                              )}
                              error={
                                !this.props.formatDollar(
                                  invoiceItem['discount']
                                )
                              }
                              helperText={
                                this.props.itemError.index === index &&
                                this.props.itemError.id === 'discount'
                                  ? 'Field is required'
                                  : ''
                              }
                              onChange={(e) =>
                                this.props.handleItemChange(
                                  e.target.name,
                                  e.target.value,
                                  index
                                )
                              }
                              onBlur={(e) =>
                                this.props.handleBlurField(
                                  e.target.name,
                                  e.target.value,
                                  index
                                )
                              }
                            />
                            <div className="discountPercentage">
                              {(() => {
                                const discount = Number(
                                  invoiceItem['discount'] || 0
                                );
                                const unitPrice = Number(
                                  invoiceItem['unitPrice'] || 0
                                );
                                const quantity = Number(
                                  invoiceItem['quantity'] || 0
                                );
                                const percent =
                                  unitPrice && quantity
                                    ? (
                                        (discount / (unitPrice * quantity)) *
                                        100
                                      ).toFixed(2)
                                    : '0';
                                return `(${percent}%)`;
                              })()}
                            </div>
                          </div>
                          {INVOICE_ITEM_CELLS_RIGHT.map((item, i) => (
                            <TextField
                              style={{ width: '10%' }}
                              key={
                                'item' +
                                (i + INVOICE_ITEM_CELLS_LEFT.length + 1)
                              }
                              variant="outlined"
                              label={item.label + '*'}
                              InputLabelProps={{ shrink: true }}
                              inputProps={{
                                style: {
                                  textAlign: item.rightAlign ? 'right' : 'left',
                                },
                              }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    {item.addDollar ? '$' : ''}
                                  </InputAdornment>
                                ),
                                readOnly: item.readOnly,
                              }}
                              name={item.id}
                              value={
                                item.addDollar
                                  ? this.props.formatDollar(
                                      invoiceItem[item.id]
                                    )
                                  : invoiceItem[item.id]
                              }
                              error={
                                !(item.addDollar
                                  ? this.props.formatDollar(
                                      invoiceItem[item.id]
                                    )
                                  : invoiceItem[item.id])
                              }
                              helperText={
                                this.props.itemError.index === index &&
                                this.props.itemError.id === item.id
                                  ? 'Field is required'
                                  : ''
                              }
                              onChange={(e) =>
                                this.props.handleItemChange(
                                  e.target.name,
                                  e.target.value,
                                  index
                                )
                              }
                              onBlur={(e) =>
                                this.props.handleBlurField(
                                  e.target.name,
                                  e.target.value,
                                  index
                                )
                              }
                            />
                          ))}
                          <div
                            style={{
                              width: '10%',
                              display: 'flex',
                              alignItems: 'flex-start',
                              flexDirection: 'column',
                            }}
                          >
                            <TextField
                              style={{ width: '100%' }}
                              key={'item' + INVOICE_ITEM_CELLS_LEFT.length}
                              variant="outlined"
                              label={'Tax*'}
                              InputLabelProps={{ shrink: true }}
                              inputProps={{ style: { textAlign: 'right' } }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    {'$'}
                                  </InputAdornment>
                                ),
                                readOnly: false,
                              }}
                              name={'tax'}
                              value={this.props.formatDollar(
                                invoiceItem['tax']
                              )}
                              error={
                                !this.props.formatDollar(invoiceItem['tax'])
                              }
                              helperText={
                                this.props.itemError.index === index &&
                                this.props.itemError.id === 'tax'
                                  ? 'Field is required'
                                  : ''
                              }
                              onChange={(e) =>
                                this.props.handleItemChange(
                                  e.target.name,
                                  e.target.value,
                                  index
                                )
                              }
                              onBlur={(e) =>
                                this.props.handleBlurField(
                                  e.target.name,
                                  e.target.value,
                                  index
                                )
                              }
                            />
                            <div className="discountPercentage">
                              {(() => {
                                const tax = Number(
                                  String(invoiceItem['tax'] || 0).replace(
                                    /,/g,
                                    ''
                                  )
                                );
                                const amount = Number(
                                  String(invoiceItem['amount'] || 0).replace(
                                    /,/g,
                                    ''
                                  )
                                );
                                const percent =
                                  amount && !isNaN(amount) && !isNaN(tax)
                                    ? ((tax / amount) * 100).toFixed(2)
                                    : '0.00';
                                return `(${percent}%)`;
                              })()}
                            </div>
                          </div>
                          <div style={{ width: '205px', textAlign: 'left' }}>
                            {this.state.deleteIndex === index ? (
                              <>
                                <Button
                                  onClick={() =>
                                    this.setState({ deleteIndex: -1 })
                                  }
                                >
                                  Cancel
                                </Button>
                                <Button
                                  onClick={() => {
                                    this.props.handleItemDelete(index);
                                    this.setState({ deleteIndex: -1 });
                                  }}
                                  variant="contained"
                                  startIcon={<DeleteIcon />}
                                >
                                  Delete
                                </Button>
                              </>
                            ) : (
                              <IconButton
                                onClick={() =>
                                  this.setState({ deleteIndex: index })
                                }
                              >
                                <RemoveCircleIcon
                                  fontSize="small"
                                  color="error"
                                />
                              </IconButton>
                            )}
                          </div>
                        </div>
                        {index !==
                          this.props.editing.supplierInvoiceItems.length -
                            1 && <br />}
                      </React.Fragment>
                    )
                  ) || <br />}
                  <IconButton onClick={this.props.addItem}>
                    <AddCircleIcon fontSize="small" color="secondary" />
                  </IconButton>
                  {hasLineItems && (
                    <div
                      className="lineItemRow"
                      style={{ marginBottom: '23px' }}
                    >
                      <div style={{ width: '10%' }}></div>
                      <div style={{ width: '10%' }}></div>
                      <div style={{ width: '10%' }}></div>
                      <div style={{ width: '10%' }}></div>
                      <div style={{ width: '10%' }}></div>
                      <TextField
                        style={{ width: '10%' }}
                        label="Amount SubTotal"
                        multiline
                        rowsMax={8}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ style: { textAlign: 'right' } }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          ),
                        }}
                        value={
                          this.props.editing.amountSubTotal
                            ? this.props.formatDollar(
                                this.props.editing.amountSubTotal,
                                true
                              )
                            : this.getAmountSubTotal()
                        }
                        variant="outlined"
                      />
                      <TextField
                        style={{ width: '10%' }}
                        label="Tax SubTotal"
                        multiline
                        rowsMax={8}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ style: { textAlign: 'right' } }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          ),
                        }}
                        value={
                          this.props.editing.taxSubTotal
                            ? this.props.formatDollar(
                                this.props.editing.taxSubTotal,
                                true
                              )
                            : this.getTaxSubTotal()
                        }
                        variant="outlined"
                      />
                      <div style={{ width: '205px', textAlign: 'left' }}></div>
                    </div>
                  )}
                </div>
                <Divider className="divider" />
                <br />
                <div className="notesAndTotals">
                  <div className="invoiceNotes">
                    <div style={{ paddingBottom: '10px' }}>
                      <TextField
                        label="Notes"
                        multiline
                        rowsMax={8}
                        InputLabelProps={{ shrink: true }}
                        style={{ width: '100%' }}
                        name="notes"
                        value={
                          this.props.editing.notes
                            ? this.props.editing.notes
                            : ''
                        }
                        onChange={(e) =>
                          this.props.handleChange(e.target.name, e.target.value)
                        }
                        variant="outlined"
                      />
                    </div>
                    {this.props.editing.statusText &&
                    this.props.editing.statusText.length !== 0 ? (
                      <div className="needs-review-container">
                        <Typography
                          variant="h6"
                          component="div"
                          gutterBottom
                          className="form-header"
                        ></Typography>
                        <div className="statusText-content">
                          <TableContainer>
                            <Table
                              size={'medium'}
                              stickyHeader
                              aria-label="sticky table"
                            >
                              <TableHead>
                                <TableRow>
                                  <TableCell className="cellPadding">
                                    <p className={styles.cardTotalHeader}>
                                      Issues:
                                    </p>
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {this.props.editing.statusText.map(
                                  (report, index) => (
                                    <TableRow hover key={index}>
                                      <TableCell className="cellPadding">
                                        <p className={styles.cardCellItems}>
                                          {report}
                                        </p>
                                      </TableCell>
                                    </TableRow>
                                  )
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <div className="totals">
                    <TextField
                      variant="outlined"
                      label="Subtotal"
                      InputLabelProps={{ shrink: true }}
                      name="invoiceSubTotal"
                      value={this.props.formatDollar(
                        this.props.editing.invoiceSubTotal
                      )}
                      error={
                        !this.props.formatDollar(
                          this.props.editing.invoiceSubTotal
                        )
                      }
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">$</InputAdornment>
                        ),
                      }}
                      inputProps={{ style: { textAlign: 'right' } }}
                      onChange={(e) =>
                        this.props.handleChange(e.target.name, e.target.value)
                      }
                      onBlur={(e) =>
                        this.props.handleBlurField(
                          e.target.name,
                          e.target.value,
                          -1
                        )
                      }
                    />
                    <br />
                    <TextField
                      variant="outlined"
                      label="Tax"
                      InputLabelProps={{ shrink: true }}
                      name="invoiceTax"
                      value={this.props.formatDollar(
                        this.props.editing.invoiceTax
                      )}
                      error={
                        !this.props.formatDollar(this.props.editing.invoiceTax)
                      }
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">$</InputAdornment>
                        ),
                      }}
                      inputProps={{ style: { textAlign: 'right' } }}
                      onChange={(e) =>
                        this.props.handleChange(e.target.name, e.target.value)
                      }
                      onBlur={(e) =>
                        this.props.handleBlurField(
                          e.target.name,
                          e.target.value,
                          -1
                        )
                      }
                    />
                    <br />
                    <TextField
                      variant="outlined"
                      label="Total"
                      InputLabelProps={{ shrink: true }}
                      name="invoiceTotal"
                      value={this.props.formatDollar(
                        this.props.editing.invoiceTotal
                      )}
                      error={
                        !this.props.formatDollar(
                          this.props.editing.invoiceTotal
                        )
                      }
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">$</InputAdornment>
                        ),
                      }}
                      inputProps={{ style: { textAlign: 'right' } }}
                      onChange={(e) =>
                        this.props.handleChange(e.target.name, e.target.value)
                      }
                      onBlur={(e) =>
                        this.props.handleBlurField(
                          e.target.name,
                          e.target.value,
                          -1
                        )
                      }
                    />
                    <br />
                    {this.props.user.routes.includes('accounting') && (
                      <>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            name="paymentDate"
                            label="Payment Date"
                            value={
                              this.props.editing?.paymentDate
                                ? parseISO(this.props.editing?.paymentDate)
                                : null
                            }
                            onChange={(date) => {
                              if (!date || isNaN(date.getTime())) {
                                this.props.handleChange('paymentDate', null);
                                return;
                              }

                              const formattedDate = format(date, 'yyyy-MM-dd');
                              this.props.handleChange(
                                'paymentDate',
                                formattedDate
                              );
                            }}
                            format="yyyy-MM-dd"
                            variant="inline"
                            inputVariant="outlined"
                            InputLabelProps={{ shrink: true }}
                            InputAdornmentProps={{ position: 'start' }}
                            autoOk
                          />
                        </MuiPickersUtilsProvider>
                        <br />
                        <Autocomplete
                          options={this.props.bankAccounts}
                          getOptionLabel={(option) =>
                            option.name && option.accountNumber
                              ? `${option.name} (${option.accountNumber})`
                              : ``
                          }
                          value={this.props.editing.bankAccount}
                          onChange={(e, value) =>
                            this.props.handleChange('bankAccount', value)
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="bankAccount"
                              label="Bank Account"
                              variant="outlined"
                              InputLabelProps={{ shrink: true }}
                            />
                          )}
                        />
                        <br />
                        <TextField
                          variant="outlined"
                          name="referenceId"
                          label="Reference Id"
                          value={this.props.editing?.referenceId}
                          onChange={(e) =>
                            this.props.handleChange(
                              e.target.name,
                              e.target.value
                            )
                          }
                          InputLabelProps={{ shrink: true }}
                        />
                      </>
                    )}
                  </div>
                </div>
                <Divider className="divider" />
                <br />
                <Typography
                  variant="h5"
                  style={{ alignSelf: 'flex-start', marginBottom: '10px' }}
                >
                  Attachments
                </Typography>
                <div className="attachmentsRow">
                  <Tooltip
                    style={{ marginLeft: '2px' }}
                    enterTouchDelay={0}
                    leaveTouchDelay={30000}
                    enterDelay={400}
                    // leaveDelay={1000000} // for testing purposes
                    title={<React.Fragment>{ATTACHMENTS_INFO}</React.Fragment>}
                  >
                    <IconButton aria-label="info">
                      <InfoOutlinedIcon variant="outlined" fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  {this.props.editing.files?.length > 0
                    ? this.props.editing.files?.map((file, index) => {
                        let label = index + 1;
                        if (
                          Object.keys(file).length > 0 &&
                          Object.keys(file).includes('displayName') &&
                          (file.displayName.includes('.pdf') ||
                            file.displayName.includes('.PDF'))
                        ) {
                          return (
                            <div className="pdf-icon">
                              <div style={{ position: 'relative' }}>
                                <IconButton
                                  style={{ position: 'relative' }}
                                  aria-label="previous"
                                  onClick={() =>
                                    this.props.handleAttachmentPreview(
                                      file,
                                      index
                                    )
                                  }
                                >
                                  <DescriptionIcon
                                    variant="outlined"
                                    fontSize="large"
                                  />
                                </IconButton>
                                <div
                                  style={{
                                    position: 'absolute',
                                    top: '40px',
                                    left: '30px',
                                    fontSize: '15px',
                                    color: 'black',
                                  }}
                                >
                                  {file.displayName.length > 10
                                    ? file.displayName.substring(0, 5) + '...'
                                    : file.displayName}
                                </div>
                              </div>
                            </div>
                          );
                        } else {
                          return null;
                        }
                      })
                    : null}
                </div>
                <div style={{ alignSelf: 'flex-start' }}>
                  <FileUpload
                    handleFileAdd={(file) =>
                      this.props.handleGeneralFileAdd(file)
                    }
                    handleFileDelete={(file, fileIndex) =>
                      this.props.handleGeneralFileDelete(file, fileIndex)
                    }
                    files={this.props.newFiles ? this.props.newFiles : []}
                    fetchFilePreview={null}
                    singleFileUpload={true}
                    isPackingSlip={true}
                  />
                </div>
              </div>
            )}
          </>
        );
    }
}

export default EditInvoices